<template>
  <div class="header-calc">
    <p class="header-calc__main-description">
      <slot />
    </p>
  </div>
</template>

<script setup></script>

<style lang="scss" scoped>
.header-calc {
  &__main-description {
    max-width: 1154px;
    width: 100%;

    @include font(20, 24, 400);
    text-align: center;
    letter-spacing: 0.02em;
    color: #0e0f0f;

    margin: 0 auto;

    @include bigMobile {
      @include font(16, 22);
    }
  }
}
</style>
